import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, getCurrentInstance } from 'vue';
import PaymentTypeRepository from '@/repositories/PaymentTypeRepository';
import BankAccountRepository from '@/repositories/BankAccountRepository';
import CurrencyRepository from '@/repositories/CurrencyRepository';

interface Props {
    taxId: any;
    registerId: any;
    isTaxPayer: any;
    webpage: any;
    bankCode: any;
    currency: any;
    paymentType: any;
    isCompany: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaxesPaymentSection',
  props: {
    taxId: null,
    registerId: null,
    isTaxPayer: null,
    webpage: null,
    bankCode: null,
    currency: null,
    paymentType: null,
    isCompany: null
  },
  emits: ["update:taxId", "update:registerId", "update:isTaxPayer", "update:webpage", "update:bankCode", "update:currency", "update:paymentType"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:taxId', value: string): void;
    (e: 'update:registerId', value: string): void;
    (e: 'update:isTaxPayer', value: boolean): void;
    (e: 'update:webpage', value: string): void;
    (e: 'update:bankCode', value: string): void;
    (e: 'update:currency', value: string): void;
    (e: 'update:paymentType', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    taxId: any;
    registerId: any;
    isTaxPayer: any;
    webpage: any;
    bankCode: any;
    currency: any;
    paymentType: any;
    isCompany: any;
};



// Template refs for validation border styling
const tax = ref<HTMLElement | null>(null);

// Expose refs for parent component access
expose({
    tax,
});



const proxy = getCurrentInstance()?.proxy as any;

const selectedBankAccount = ref(props.bankCode || '');
const selectedIsTaxPayerOption = ref(props.isTaxPayer ? 1 : 0);

const booleanOptions = computed(() => [
    {
        id: 0,
        value: false,
        name: proxy.$t('No'),
    },
    {
        id: 1,
        value: true,
        name: proxy.$t('Yes'),
    },
]);

const currencies = computed(() => CurrencyRepository.getAll());
const paymentTypes = computed(() => PaymentTypeRepository.getAllWithArchived());
const bankAccounts = computed(() => BankAccountRepository.getAllWithFormattedName());

const onSelectedBankAccountChange = (value: string) => {
    selectedBankAccount.value = value;
    const bank = bankAccounts.value.find((b: any) => b.id === value);
    emit('update:bankCode', bank?.accountNumber || '');
};

const onSelectedIsTaxPayerOptionChange = (value: number) => {
    selectedIsTaxPayerOption.value = value;
    emit('update:isTaxPayer', value === 1);
};

watch(
    () => props.bankCode,
    (newVal) => {
        selectedBankAccount.value = newVal || '';
    },
    { immediate: true },
);

watch(
    () => props.isTaxPayer,
    (newVal) => {
        selectedIsTaxPayerOption.value = newVal ? 1 : 0;
    },
    { immediate: true },
);

return { __sfc: true,props, tax, emit, proxy, selectedBankAccount, selectedIsTaxPayerOption, booleanOptions, currencies, paymentTypes, bankAccounts, onSelectedBankAccountChange, onSelectedIsTaxPayerOptionChange }
}

})